module.exports = __webpack_public_path__ + "img/pos-logo.233e1159.svg";